function ObservationResultRequestMeedyVO(idObservationResultSegment, segmentId, resultType, parameterId, parameterCode, parameterName,
                                    patameterSystemCode, values, unit, lowerRange, upperRange, rangeComment, parameterFlag, resultFlag,
                                    date, observationResult) {

    this.idObservationResultSegment = idObservationResultSegment;
    this.segmentId = segmentId;
    this.resultType = resultType;
    this.parameterId = parameterId;
    this.parameterCode = parameterCode;
    this.parameterName = parameterName;
    this.patameterSystemCode = patameterSystemCode;
    this.values = values;
    this.unit = unit;
    this.lowerRange = lowerRange;
    this.upperRange = upperRange;
    this.rangeComment = rangeComment;
    this.parameterFlag = parameterFlag;
    this.resultFlag = resultFlag;
    this.date = date;
    this.observationResult = observationResult;

    var _typeContext = {
        values : ObservationResultSegmentValueMeedyVO,
        date : Date,
        observationResult : ObservationResultMeedyVO
    };

    this._getType = function (property) {
        if (_typeContext.hasOwnProperty(property)) {
            return _typeContext[property];
        }
        else {
            return undefined;
        }
    };

    var _mappingContext = {
    };

    this._getMapping = function (property) {
        if (_mappingContext[property]) {
            return _mappingContext[property];
        }
        else {
            return undefined;
        }
    };
}
